import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import IconButton, { IconButtonProps } from "@mui/material/IconButton";

/**
 * Standard destructive control for grids and forms: outlined trash + theme error color.
 */
export default function DeleteOutlineIconButton(props: IconButtonProps) {
  const { children, ...rest } = props;
  return (
    <IconButton size="small" color="error" {...rest}>
      {children ?? <DeleteOutlineIcon fontSize="small" />}
    </IconButton>
  );
}
